import React from 'react';
import ChristmasScene from './components/ChristmasScene';

const App = () => {
  return (
    <div className="App">
      <ChristmasScene />
    </div>
  );
};

export default App;